module.exports = __webpack_public_path__ + "media/images/ywca-d2052d05cd83b94ca04a0eabd0c96eca.png";